import React from "react";

export function IconesAtingidas(props) {
    return (
        <>
            {new Array(3).fill(null).map((_, i) => {
                return (
                    <div
                        key={i}
                        style={{
                            width: 25,
                            height: 30,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: i + 1 <= props.item.atingidas ? "transparent" : "#efefef",
                        }}
                    >
                        <i
                            style={{
                                color: i + 1 <= props.item.atingidas ? "#006224" : "#E22",
                                fontSize: "0.8rem",
                            }}
                            className={i + 1 <= props.item.atingidas ? "fas fa-check" : "fas fa-minus"}
                        ></i>
                    </div>
                );
            })}
        </>
    );
}
